export default {
  isAuthenticated: false,
  me: {}
};